import ServiceGroupsPage from "./ServiceGroups/ServiceGroupsPage";

export default ServiceGroupsPage;
